import { render, staticRenderFns } from "./TopUpPayment.vue?vue&type=template&id=5e5591af&scoped=true"
import script from "./TopUpPayment.vue?vue&type=script&lang=js"
export * from "./TopUpPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5591af",
  null
  
)

export default component.exports